// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface GetCategoriesApiParameter extends ApiParameter {
    displayShopByCategoryFromType?: string;
    selectedCategoryIds?: string;
}

export interface ShopByCategoryModel {
    categoriesList?: CategoryModel[];
}

export interface CategoryModel {
    title?: string;
    UrlSegment?: string;
    ShortDescription?: string;
    SmallImagePath?: string;
    ImageAltText?: string;
}

const shopByCategoryApi = "api/wes/ShopByCategories";

export async function getShopbyCategories(parameter: GetCategoriesApiParameter) {
    const result = await get<ShopByCategoryModel>(`${shopByCategoryApi}/GetFeaturedCategories`, parameter);
    return result;
}
